<template>
	<div
		class="w-100 amelipro-content-layout"
		:style="bgStyle"
	>
		<div
			class="mx-auto amelipro-content-layout__content"
			:style="widthStyle"
		>
			<slot />
		</div>
	</div>
</template>

<script setup lang="ts">
	import BreakpointHelper from '../../helpers/BreakpointHelper';
	import { IndexedObject } from '../../types';
	import { computed } from 'vue';
	import { convertToHex } from '../../functions/convertToHex';

	const props = defineProps({
		bgColor: {
			type: String,
			default: 'ap-white',
		},
	});

	const breakpointHelper = new BreakpointHelper();

	const widthStyle = computed<IndexedObject>(() => {
		const styles: IndexedObject = {
			maxWidth: '100%',
			padding: '24px 10px',
		};

		if (breakpointHelper.width >= 1072) {
			styles.maxWidth = '980px';
			styles.padding = '24px 0';
		}

		if (breakpointHelper.width >= 1240) {
			styles.maxWidth = '1144px';
			styles.padding = '24px 0';
		}
		return styles;
	});

	const bgStyle = computed<IndexedObject>(() => ({ backgroundColor: convertToHex(props.bgColor) }));
</script>

<style lang="scss" scoped></style>
